'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LIVE_DEFAULT_MSA = exports.msaIdToAlias = exports.msaAliasToId = exports.msaSupportsUnifedSearch = exports.MSA_ALIAS_TO_ID = undefined;

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _msaAliasToId = require('./msa-alias-to-id');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.MSA_ALIAS_TO_ID = _msaAliasToId.MSA_ALIAS_TO_ID;


var UNIFIED_SEARCH_MSAS_ALIASES = ['australia', 'adelaide', 'brisbane', 'melbourne', 'perth', 'sydney', 'united-kingdom', 'united-states'];
var msaSupportsUnifedSearch = exports.msaSupportsUnifedSearch = function msaSupportsUnifedSearch(msa) {
  return !!(msa && UNIFIED_SEARCH_MSAS_ALIASES.includes(msa.alias));
};
var msaAliasToId = exports.msaAliasToId = function msaAliasToId(alias) {
  return _msaAliasToId.MSA_ALIAS_TO_ID[alias] || null;
};
var msaIdToAlias = exports.msaIdToAlias = function msaIdToAlias(id) {
  return (0, _keys2.default)(_msaAliasToId.MSA_ALIAS_TO_ID).find(function (key) {
    return _msaAliasToId.MSA_ALIAS_TO_ID[key] === parseInt(id, 10);
  });
};

var LIVE_DEFAULT_MSA = exports.LIVE_DEFAULT_MSA = _msaAliasToId.MSA_ALIAS_TO_ID['new-york'];